var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h26a4 4 0 014 4v26a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#0070D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.137 17.464v-2.528H18.41v-6.24h-2.784v6.24h-5.76v2.528h5.76v6.496h2.784v-6.496h5.727z",
    fill: "#fff"
  })));
}
export default SvgPlusIcon;